import * as React from 'react';

interface BreakpointRange {
  min?: number;
  max?: number;
}

export const useBreakpoint = (range: BreakpointRange) => {
  const [matches, setMatches] = React.useState<boolean>(false);

  React.useEffect(() => {
    const checkBreakpoint = () => {
      const width = window.innerWidth;
      const matchesMin = range.min ? width >= range.min : true;
      const matchesMax = range.max ? width < range.max : true;
      setMatches(matchesMin && matchesMax);
    };

    checkBreakpoint();
    window.addEventListener('resize', checkBreakpoint);
    return () => window.removeEventListener('resize', checkBreakpoint);
  }, [range.min, range.max]);

  return matches;
};
